/* The Sugar Coated Cult: the three drawn objects, turning. Plain 2D canvas, one context, no library. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (root.classList.contains('rm') || !window.requestAnimationFrame) return;
  if (window.TSCC_WIRES || !document.querySelector('[data-wires]')) return;
  window.TSCC_WIRES = true;
  var TAU = Math.PI * 2;
  function ring(y, r, n) { var p = [], i; n = n || 56; for (i = 0; i <= n; i++) p.push([Math.cos(i / n * TAU) * r, y, Math.sin(i / n * TAU) * r]); return p; }
  function slab(y, w, d, r) {
    var p = [], c = [[w - r, d - r, 0], [-w + r, d - r, 1], [-w + r, -d + r, 2], [w - r, -d + r, 3]], k, i, a;
    for (k = 0; k < 4; k++) for (i = 0; i <= 8; i++) { a = (c[k][2] + i / 8) * TAU / 4; p.push([c[k][0] + Math.cos(a) * r, y, c[k][1] + Math.sin(a) * r]); }
    p.push(p[0]); return p;
  }
  function posts(a, b, every) { var out = [], i; for (i = 0; i < a.length - 1; i += every) out.push([a[i], b[i]]); return out; }
  function spokes(y, r, n) { var out = [], i; for (i = 0; i < n; i++) out.push([[0, y, 0], [Math.cos(i / n * TAU) * r, y, Math.sin(i / n * TAU) * r]]); return out; }
  function dome(y, r, n) { var out = [], i, a; for (i = 1; i <= n; i++) { a = i / (n + 1) * Math.PI / 2; out.push(ring(y - Math.sin(a) * r, Math.cos(a) * r)); } return out; }
  var MAKE = {
    tin: function () {
      var b0 = ring(-0.3, 1), b1 = ring(0.12, 1), l0 = ring(0.12, 1.04), l1 = ring(0.3, 1.04);
      return { scale: 0.34, pitch: 0.62, parts: [
        { lines: [b0, b1, ring(-0.09, 1)].concat(posts(b0, b1, 4)).concat(spokes(-0.3, 1, 14)) },
        { lift: 0.5, lines: [l0, l1, ring(0.3, 0.86)].concat(posts(l0, l1, 2)), logo: { y: 0.3, w: 1.34 } }
      ] };
    },
    tray: function () {
      var b0 = slab(-0.34, 1.25, 0.8, 0.16), b1 = slab(-0.1, 1.25, 0.8, 0.16), i0 = slab(-0.1, 1.13, 0.68, 0.1), l0 = slab(0.22, 1.25, 0.8, 0.16), l1 = slab(0.33, 1.25, 0.8, 0.16);
      return { scale: 0.3, pitch: 0.55, parts: [
        { lines: [b0, b1, i0, slab(-0.3, 1.13, 0.68, 0.1)].concat(posts(b0, b1, 3)) },
        { lift: 0.55, lines: [l0, l1].concat(posts(l0, l1, 3)), logo: { y: 0.33, w: 1.5 } }
      ] };
    },
    t: function () {
      var o = [[-1, 0.9], [1, 0.9], [1, 0.42], [0.27, 0.42], [0.27, -0.9], [-0.27, -0.9], [-0.27, 0.42], [-1, 0.42], [-1, 0.9]];
      var f = o.map(function (q) { return [q[0], q[1], 0.26]; }), k = o.map(function (q) { return [q[0], q[1], -0.26]; });
      return { scale: 0.36, pitch: 0.5, tilt: -0.5, parts: [{ lines: [f, k].concat(posts(f, k, 1)) }] };
    },
    tube: function () {
      var r = 0.2, t0 = ring(0.62, r, 40), t1 = ring(-0.86, r, 40), c0 = ring(0.82, 0.25, 40), c1 = ring(1.12, 0.25, 40);
      return { scale: 0.36, pitch: 0.3, tilt: 0.42, parts: [
        { lines: [t0, t1, ring(0.2, r, 40), ring(-0.3, r, 40)].concat(posts(t0, t1, 5)).concat(dome(-0.86, r, 3)).concat([ring(0.4, 0.14, 32), ring(-0.7, 0.14, 32)]).concat(posts(ring(0.4, 0.14, 32), ring(-0.7, 0.14, 32), 8)) },
        { lift: 0.4, lines: [c0, c1, ring(0.92, 0.25, 40), ring(1.02, 0.25, 40), ring(1.12, 0.17, 32)].concat(posts(c0, c1, 2)) }
      ] };
    }
  };
  var logo = new Image(), logoOk = false;
  logo.onload = function () { logoOk = true; };
  logo.src = document.querySelector('[data-wires]').getAttribute('data-logo');
  [].slice.call(document.querySelectorAll('[data-wires]')).forEach(function (stage) {
  var cv = document.createElement('canvas'), ctx = cv.getContext && cv.getContext('2d');
  if (!ctx) return;
  var items = [].slice.call(stage.querySelectorAll('[data-wire]')).map(function (el) {
    var kind = el.getAttribute('data-wire'); if (!MAKE[kind]) return null;
    var m = MAKE[kind]();
    return { el: el, m: m, yaw: kind === 'tin' ? 0.5 : kind === 'tray' ? -0.6 : 0.2, vel: 0.28, px: 0, py: 0, tx: 0, ty: 0, lift: 0, want: 0, drag: null };
  }).filter(Boolean);
  if (!items.length) return;
  stage.appendChild(cv); stage.classList.add('wire-live');
  var W = 0, H = 0, dpr = 1, run = false, last = 0, drawn = 0, seen = false, box;
  function fit() {
    dpr = Math.min(window.devicePixelRatio || 1, 2); W = stage.clientWidth; H = stage.clientHeight;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    box = stage.getBoundingClientRect();
    items.forEach(function (it) { var b = it.el.getBoundingClientRect(); it.x = b.left - box.left; it.y = b.top - box.top; it.w = b.width; it.h = b.height; });
  }
  function frame(t) {
    if (!run) return;
    var dt = Math.min(0.05, (t - last) / 1000 || 0.016); last = t;
    if (seen && drawn < 1) drawn = Math.min(1, drawn + dt / 1.4);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    items.forEach(function (it) {
      var m = it.m, s = Math.min(it.w, it.h) * m.scale, cx = it.x + it.w / 2, cy = it.y + it.h / 2;
      if (!it.drag) { it.yaw += it.vel * dt; it.vel += (0.28 - it.vel) * Math.min(1, dt * 1.2); }
      it.px += (it.tx - it.px) * Math.min(1, dt * 6); it.py += (it.ty - it.py) * Math.min(1, dt * 6);
      it.lift += (it.want - it.lift) * Math.min(1, dt * 7);
      var yaw = it.yaw + it.px * 0.5, pitch = m.pitch + it.py * 0.35, tilt = m.tilt || 0;
      var cyw = Math.cos(yaw), syw = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch), ct = Math.cos(tilt), st = Math.sin(tilt);
      var P = function (v, up) {
        var x = v[0], y = v[1] + up, z = v[2], x1 = x * cyw + z * syw, z1 = -x * syw + z * cyw;
        var x2 = x1 * ct - y * st, y2 = x1 * st + y * ct;
        return [cx + x2 * s, cy - (y2 * cp - z1 * sp) * s];
      };
      ctx.strokeStyle = '#0a0a08'; ctx.lineWidth = Math.max(1, s / 150);
      m.parts.forEach(function (part) {
        var up = (part.lift || 0) * it.lift, i, j, line, n, p;
        ctx.beginPath();
        for (i = 0; i < part.lines.length; i++) {
          line = part.lines[i]; n = Math.max(2, Math.ceil(line.length * drawn));
          for (j = 0; j < n; j++) { p = P(line[j], up); if (j) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); }
        }
        ctx.stroke();
        if (part.logo && logoOk && drawn > 0.6) {
          var o = P([0, part.logo.y, 0], up), u = P([1, part.logo.y, 0], up), w = P([0, part.logo.y, 1], up), lw = part.logo.w, lh = lw * logo.height / logo.width;
          ctx.save(); ctx.globalAlpha = (drawn - 0.6) / 0.4;
          ctx.transform(u[0] - o[0], u[1] - o[1], w[0] - o[0], w[1] - o[1], o[0], o[1]);
          ctx.drawImage(logo, -lw / 2, -lh / 2, lw, lh); ctx.restore();
        }
      });
    });
    requestAnimationFrame(frame);
  }
  items.forEach(function (it) {
    var el = it.el;
    el.addEventListener('pointermove', function (e) {
      var b = el.getBoundingClientRect();
      if (it.drag) { var dx = e.clientX - it.drag.x; it.drag.x = e.clientX; it.yaw += dx * 0.012; it.vel = dx * 0.012 * 60 * 0.5; }
      else if (e.pointerType === 'mouse') { it.tx = (e.clientX - b.left) / b.width - 0.5; it.ty = (e.clientY - b.top) / b.height - 0.5; it.want = 1; }
    });
    el.addEventListener('pointerdown', function (e) { it.drag = { x: e.clientX }; if (e.pointerType !== 'mouse') it.want = it.want ? 0 : 1; });
    var end = function () { it.drag = null; };
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', function (e) { it.drag = null; if (e.pointerType === 'mouse') { it.tx = it.ty = 0; it.want = 0; } });
  });
  fit();
  var rz; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(fit, 150); });
  if ('ResizeObserver' in window) new ResizeObserver(function () { fit(); }).observe(stage);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  addEventListener('load', fit);
  new IntersectionObserver(function (es) {
    var on = es[0].isIntersecting;
    if (on) { seen = true; fit(); if (!run) { run = true; last = performance.now(); requestAnimationFrame(frame); } } else run = false;
  }, { threshold: 0.05 }).observe(stage);
  });
})();
